import {config} from "./config";
import {request} from "./request";

function updateMpAuthConfig(data, cb, fail_cb) {
    request.post.call(this, config.apiList.mpAuthConfigs, data, null, cb, fail_cb)
}

function updateNotBindSettings(data, cb, fail_cb) {
    request.post.call(this, config.apiList.notBindSettings, data, null, cb, fail_cb)
}

function otherSettings(data, cb, fail_cb) {
    request.post.call(this, config.apiList.otherSettings, data, null, cb, fail_cb)
}

function getMpAuthConfigs(data, cb, fail_cb) {
    request.get.call(this, config.apiList.mpAuthConfigs, data, cb, fail_cb)
}



var mpAuthConfigApi = {
    getMpAuthConfigs: getMpAuthConfigs,
    updateMpAuthConfig: updateMpAuthConfig,
    updateNotBindSettings: updateNotBindSettings,
    otherSettings
}

export {mpAuthConfigApi}